import { doAjax } from './helper'
import { getInteriorImageForStoredComponent} from './imagesLogicController'
import { saveStateWithAjax, getPackageImageSource, checkKey, checkSubmit } from './screen-package-selection-global'


function checkSeatsAndSteeringWheelBadges_a5_s_line() {
	const imgSource = 'img/01_interieur/paketauswahl/au513_e-tron_gt_paketauswahl_rs_badges_zierleiste.png'
}


function addListeners_a5_s_line(frontCheckboxesMap, modalsCheckboxesMap) {

	//console.log("reload? 0")
	// Remove YFB layer onLoad if package and YN1 OR YN2 active
	function checkYFB() {
		document.getElementById("YFB_A5-img").hidden = true;
		//console.log("reload? 1")
	}
	function checkYFB_YN1() {
		document.getElementById("YFB_A5-img").hidden = true;
		//console.log("reload? 2")
	}
	if ((frontCheckboxesMap['YFB_A5'].checked == true) && (frontCheckboxesMap['YN1_A5'].checked == true)) { 
		setTimeout(checkYFB_YN1, 100);
	}
	if ((frontCheckboxesMap['YFB_A5'].checked == true) && (frontCheckboxesMap['YN2_A5'].checked == true)) { 
		setTimeout(checkYFB, 100);
	}

    frontCheckboxesMap['FC1_A5'].addEventListener('change', function () {
		checkSubmit(frontCheckboxesMap)
		saveStateWithAjax('FC1_A5', this.checked);
		if (this.checked) {
			//If we dont come from the modal
			if (frontCheckboxesMap['YN1_A5'].checked == false) { 
				frontCheckboxesMap['YN1_A5'].disabled = true
			}
			//If we dont come from the modal
			if (frontCheckboxesMap['YN2_A5'].checked == false) { 
				frontCheckboxesMap['YN2_A5'].disabled = true
			}
			if (frontCheckboxesMap['YFB_A5'].checked == false) { 
				frontCheckboxesMap['YFB_A5'].disabled = true
			}
		} else {
			checkLocks_a5_s_line(frontCheckboxesMap)
		}
		getPackageImages_a5_s_line('FC1_A5', frontCheckboxesMap)
	})

    frontCheckboxesMap['Q8H_A5'].addEventListener('change', function () {
		checkSubmit(frontCheckboxesMap)
		saveStateWithAjax('Q8H_A5', this.checked);
		if (this.checked) {
			//If we dont come from the modal
			if (frontCheckboxesMap['YN1_A5'].checked == false) { 
				frontCheckboxesMap['YN1_A5'].disabled = true
			}
			//If we dont come from the modal
			if (frontCheckboxesMap['YN2_A5'].checked == false) { 
				frontCheckboxesMap['YN2_A5'].disabled = true
			}
			if (frontCheckboxesMap['YFB_A5'].checked == false) { 
				frontCheckboxesMap['YFB_A5'].disabled = true
			}
		} else {
			checkLocks_a5_s_line(frontCheckboxesMap)
		}
		getPackageImages_a5_s_line('Q8H_A5', frontCheckboxesMap)
	})

	frontCheckboxesMap['0UD_A5'].addEventListener('change', function () {
		checkSubmit(frontCheckboxesMap)
		saveStateWithAjax('0UD_A5', this.checked);
		if (this.checked) {
			//If we dont come from the modal
			if (frontCheckboxesMap['YN1_A5'].checked == false) { 
				frontCheckboxesMap['YN1_A5'].disabled = true
			}
			//If we dont come from the modal
			if (frontCheckboxesMap['YN2_A5'].checked == false) { 
				frontCheckboxesMap['YN2_A5'].disabled = true
			}
			if (frontCheckboxesMap['YFB_A5'].checked == false) { 
				frontCheckboxesMap['YFB_A5'].disabled = true
			}
		} else {
			checkLocks_a5_s_line(frontCheckboxesMap)
		}
		getPackageImages_a5_s_line('0UD_A5', frontCheckboxesMap)
	})
		
	frontCheckboxesMap['7TZ_A5'].addEventListener('change', function () {
			checkSubmit(frontCheckboxesMap)
			saveStateWithAjax('7TZ_A5', this.checked);
			if (this.checked) {
				//If we dont come from the modal
	
			} else {
				checkLocks_a5_s_line(frontCheckboxesMap)
			}
			getPackageImages_a5_s_line('7TZ_A5', frontCheckboxesMap)
		})
	

    
	frontCheckboxesMap['FZ8_A5'].addEventListener('change', function () {
		checkSubmit(frontCheckboxesMap)
		saveStateWithAjax('FZ8_A5',this.checked)
		if (this.checked) {
			//If we dont come from the modal
			if (frontCheckboxesMap['FZ9_A5'].checked == false) { 
				frontCheckboxesMap['FZ9_A5'].disabled = true
			}
		} else {
			checkLocks_a5_s_line(frontCheckboxesMap)
		}
		getPackageImages_a5_s_line('FZ8_A5', frontCheckboxesMap)
	})
	
    
	frontCheckboxesMap['FZ9_A5'].addEventListener('change', function () {

		checkSubmit(frontCheckboxesMap)
		saveStateWithAjax('FZ9_A5',this.checked)
		if (this.checked) {
			//If we dont come from the modal
			if (frontCheckboxesMap['FZ8_A5'].checked == false) { 
				frontCheckboxesMap['FZ8_A5'].disabled = true
			}
		} else {
			checkLocks_a5_s_line(frontCheckboxesMap)
		}
		getPackageImages_a5_s_line('FZ9_A5', frontCheckboxesMap)
	})
	

    frontCheckboxesMap['0TF_A5'].addEventListener('change', function () {
		checkSubmit(frontCheckboxesMap)
		saveStateWithAjax('0TF_A5', this.checked);
		if (this.checked) {
			//If we dont come from the modal
			if (frontCheckboxesMap['YN1_A5'].checked == false) { 
				frontCheckboxesMap['YN1_A5'].disabled = true
			}
			//If we dont come from the modal
			if (frontCheckboxesMap['YN2_A5'].checked == false) { 
				frontCheckboxesMap['YN2_A5'].disabled = true
			}
			if (frontCheckboxesMap['YFB_A5'].checked == false) { 
				frontCheckboxesMap['YFB_A5'].disabled = true
			}
		} else {
			checkLocks_a5_s_line(frontCheckboxesMap)
		}
		getPackageImages_a5_s_line('0TF_A5', frontCheckboxesMap)
	})


	frontCheckboxesMap['YN1_A5'].addEventListener('change', function () {
		
		//Basisbild austauschen
		updateBackgroundImage();

		checkSubmit(frontCheckboxesMap)
		saveStateWithAjax('YN1_A5', this.checked);
		if (this.checked) {
			//If we dont come from the modal
			if (frontCheckboxesMap['YN2_A5'].checked == false) { 
				frontCheckboxesMap['YN2_A5'].disabled = true
			}
			if (frontCheckboxesMap['FC1_A5'].checked == false) { 
				frontCheckboxesMap['FC1_A5'].disabled = true
			}
			if (frontCheckboxesMap['Q8H_A5'].checked == false) { 
				frontCheckboxesMap['Q8H_A5'].disabled = true
			}
			if (frontCheckboxesMap['0UD_A5'].checked == false) { 
				frontCheckboxesMap['0UD_A5'].disabled = true
			}
			if (frontCheckboxesMap['0TF_A5'].checked == false) { 
				frontCheckboxesMap['0TF_A5'].disabled = true
			}
			if (frontCheckboxesMap['YFA_A5'].checked == false) { 
				frontCheckboxesMap['YFA_A5'].disabled = true
			}
			// Remove YFB layer if package active
			if (frontCheckboxesMap['YFB_A5'].checked == true) { 
				document.getElementById("YFB_A5-img").hidden = true;
			}
			
		} else {
			checkLocks_a5_s_line(frontCheckboxesMap)

			// Add YFB layer if package active
			if (frontCheckboxesMap['YFB_A5'].checked == true) { 
				document.getElementById("YFB_A5-img").hidden = false;
			}

			// prevent "next" button when YFB selected
			if ((frontCheckboxesMap['YFB_A5'].checked == true)) { 
				jQuery("#navigation-submit-btn").prop("disabled", true);
			}
		}
		getPackageImages_a5_s_line('YN1_A5', frontCheckboxesMap)
	})	

	frontCheckboxesMap['YN2_A5'].addEventListener('change', function () {

		//Basisbild austauschen
		updateBackgroundImage();
		
		//Basisbild austauschen
		if (frontCheckboxesMap['YN1_A5'].checked == true) {		
			//document.getElementById("front_background_image").src="img/06_paketauswahl/q7q8/paketauswahl/au53x_sport-plus_wabe_q4q_yve_frt_basis.png";
		} else {
			//document.getElementById("front_background_image").src="img/06_paketauswahl/q7q8/paketauswahl/au53x_paketauswahl_rsq8-iks.png";
		}
		//Basisbild austauschen

		checkSubmit(frontCheckboxesMap)
		saveStateWithAjax('YN2_A5', this.checked);
		if (this.checked) {
			//If we dont come from the modal
			if (frontCheckboxesMap['YN1_A5'].checked == false) { 
				frontCheckboxesMap['YN1_A5'].disabled = true
			}
			if (frontCheckboxesMap['FC1_A5'].checked == false) { 
				frontCheckboxesMap['FC1_A5'].disabled = true
			}
			if (frontCheckboxesMap['Q8H_A5'].checked == false) { 
				frontCheckboxesMap['Q8H_A5'].disabled = true
			}
			if (frontCheckboxesMap['0UD_A5'].checked == false) { 
				frontCheckboxesMap['0UD_A5'].disabled = true
			}
			if (frontCheckboxesMap['0TF_A5'].checked == false) { 
				frontCheckboxesMap['0TF_A5'].disabled = true
			}
			if (frontCheckboxesMap['YFA_A5'].checked == false) { 
				frontCheckboxesMap['YFA_A5'].disabled = true
			}

			// Remove YFB layer if package active
			if (frontCheckboxesMap['YFB_A5'].checked == true) { 
				document.getElementById("YFB_A5-img").hidden = true;
			}
			
		} else {
			checkLocks_a5_s_line(frontCheckboxesMap)

			// Add YFB layer if package active
			if (frontCheckboxesMap['YFB_A5'].checked == true) { 
				document.getElementById("YFB_A5-img").hidden = false;
			}

			// prevent "next" button when YFB selected
			if ((frontCheckboxesMap['YFB_A5'].checked == true)) { 
				jQuery("#navigation-submit-btn").prop("disabled", true);
			}
		}
		getPackageImages_a5_s_line('YN2_A5', frontCheckboxesMap)
	})	

	
	frontCheckboxesMap['YFA_A5'].addEventListener('change', function () {
		checkSubmit(frontCheckboxesMap);
		saveStateWithAjax('YFA_A5', this.checked);

		const packageIds = ["FC1_A5", "Q8H_A5", "0UD_A5", "0TF_A5"];

		if (this.checked) {
			
			// Aktiviere alle Pakete die nicht gecheckt sind
			packageIds.forEach(function (id) {
				if (!frontCheckboxesMap[id].checked) {
					frontCheckboxesMap[id].checked = true;
					frontCheckboxesMap[id].parentElement.classList.add('is-checked');
					saveStateWithAjax(id, true);
					getPackageImages_a5_s_line(id, frontCheckboxesMap);
				}
				// Deaktiviere Interaktion
				frontCheckboxesMap[id].disabled = true;
			});

			// Zusätzliche Pakete deaktivieren
			if (!frontCheckboxesMap['YFB_A5'].checked) frontCheckboxesMap['YFB_A5'].disabled = true;
			if (!frontCheckboxesMap['YN1_A5'].checked) frontCheckboxesMap['YN1_A5'].disabled = true;
			if (!frontCheckboxesMap['YN2_A5'].checked) frontCheckboxesMap['YN2_A5'].disabled = true;

		} else {
			
			// Deaktiviere alle Pakete
			packageIds.forEach(function (id) {
				if (frontCheckboxesMap[id].checked) {
					frontCheckboxesMap[id].checked = false;
					frontCheckboxesMap[id].parentElement.classList.remove('is-checked');
					saveStateWithAjax(id, false);
					getPackageImages_a5_s_line(id, frontCheckboxesMap);
				}
				// Aktiviere Interaktion wieder
				frontCheckboxesMap[id].disabled = false;
			});

			// Reaktiviere andere Pakete
			frontCheckboxesMap['YN1_A5'].disabled = false;
			frontCheckboxesMap['YN2_A5'].disabled = false;

			// Überprüfe Locks neu
			checkLocks_a5_s_line(frontCheckboxesMap);
		}

		getPackageImages_a5_s_line('YFA_A5', frontCheckboxesMap);
	});
	

	frontCheckboxesMap['YFB_A5'].addEventListener('change', function () {
		
		//Basisbild austauschen
		updateBackgroundImage();

		checkSubmit(frontCheckboxesMap)
		saveStateWithAjax('YFB_A5', this.checked);

		if (this.checked) {

			//If we dont come from the modal
			if (frontCheckboxesMap['FC1_A5'].checked == false) { 
				frontCheckboxesMap['FC1_A5'].disabled = true
			}
			if (frontCheckboxesMap['YFA_A5'].checked == false) { 
				frontCheckboxesMap['YFA_A5'].disabled = true
			}
			if (frontCheckboxesMap['Q8H_A5'].checked == false) { 
				frontCheckboxesMap['Q8H_A5'].disabled = true
			}
			if (frontCheckboxesMap['0UD_A5'].checked == false) { 
				frontCheckboxesMap['0UD_A5'].disabled = true
			}
			/*
			if (frontCheckboxesMap['7TZ_A6_C9'].checked == false) { 
				frontCheckboxesMap['7TZ_A6_C9'].disabled = true
			}	
			*/		
			/*	
			if (frontCheckboxesMap['FZ9_A5'].checked == false) { 
				frontCheckboxesMap['FZ9_A5'].disabled = true
			}
			if (frontCheckboxesMap['FZ8_A5'].checked == false) { 
				frontCheckboxesMap['FZ8_A5'].disabled = true
			}
			*/
			if (frontCheckboxesMap['0TF_A5'].checked == false) { 
				frontCheckboxesMap['0TF_A5'].disabled = true
			}

			// prevent "next" button without selecting YN1 OR YN2
			if ((frontCheckboxesMap['YN1_A5'].checked == false) && (frontCheckboxesMap['YN2_A5'].checked == false)) { 
				jQuery("#navigation-submit-btn").prop("disabled", true);
			}

			// Remove YN1/YN2 layers if packages active
			if ((frontCheckboxesMap['YN1_A5'].checked == true)) { 
				//document.getElementById("YN1_A6_C9-img").hidden = true;
			}
			if ((frontCheckboxesMap['YN2_A5'].checked == true)) { 
				document.getElementById("YN2_A5-img").hidden = true;
			}

		} else {
			checkLocks_a5_s_line(frontCheckboxesMap)

			// Add YN1/YN2 layers if packages active
			if ((frontCheckboxesMap['YN1_A5'].checked == true)) { 
				document.getElementById("YN1_A5-img").hidden = false;
			}
			if ((frontCheckboxesMap['YN2_A5'].checked == true)) { 
				document.getElementById("YN2_A5-img").hidden = false;
			}
		}
		if ((frontCheckboxesMap['YN1_A5'].checked == false)) getPackageImages_a5_s_line('YFB_A5', frontCheckboxesMap)
	})	

}

/**Controls frontcheckboxes disable */
function checkLocks_a5_s_line(frontCheckboxesMap) {
    //DEFINE UNLOCK CONDITIONS	
    const unlockConditionForFC1 = !frontCheckboxesMap['YN1_A5'].checked && !frontCheckboxesMap['YN2_A5'].checked &&  !frontCheckboxesMap['YFA_A5'].checked && !frontCheckboxesMap['YFB_A5'].checked
    const unlockConditionForYN1 = !frontCheckboxesMap['FC1_A5'].checked && !frontCheckboxesMap['YN2_A5'].checked && !frontCheckboxesMap['Q8H_A5'].checked && !frontCheckboxesMap['0UD_A5'].checked && !frontCheckboxesMap['0TF_A5'].checked
    const unlockConditionForYN2 = !frontCheckboxesMap['FC1_A5'].checked && !frontCheckboxesMap['YN1_A5'].checked && !frontCheckboxesMap['Q8H_A5'].checked && !frontCheckboxesMap['0UD_A5'].checked && !frontCheckboxesMap['0TF_A5'].checked
    const unlockConditionForQ8H_7HH = !frontCheckboxesMap['YN1_A5'].checked && !frontCheckboxesMap['YN2_A5'].checked  && !frontCheckboxesMap['YFA_A5'].checked && !frontCheckboxesMap['YFB_A5'].checked
	const unlockConditionFor0UD = !frontCheckboxesMap['YN1_A5'].checked && !frontCheckboxesMap['YN2_A5'].checked  && !frontCheckboxesMap['YFA_A5'].checked && !frontCheckboxesMap['YFB_A5'].checked
	const unlockConditionFor7TZ = true
	
	const unlockConditionForFZ8 = !frontCheckboxesMap['FZ9_A5'].checked
	const unlockConditionForFZ9 = !frontCheckboxesMap['FZ8_A5'].checked
	
	const unlockConditionFor0TF = !frontCheckboxesMap['YN1_A5'].checked && !frontCheckboxesMap['YN2_A5'].checked && !frontCheckboxesMap['YFA_A5'].checked && !frontCheckboxesMap['YFB_A5'].checked

	const unlockConditionForYFA = !frontCheckboxesMap['YN1_A5'].checked && !frontCheckboxesMap['YN2_A5'].checked && !frontCheckboxesMap['YFB_A5'].checked
	const unlockConditionForYFB = !frontCheckboxesMap['YFA_A5'].checked && !frontCheckboxesMap['0TF_A5'].checked

	frontCheckboxesMap['Q8H_A5'].disabled = !unlockConditionForQ8H_7HH
	frontCheckboxesMap['0UD_A5'].disabled = !unlockConditionFor0UD
	frontCheckboxesMap['7TZ_A5'].disabled = !unlockConditionFor7TZ
	
	frontCheckboxesMap['FZ8_A5'].disabled = !unlockConditionForFZ8
	frontCheckboxesMap['FZ9_A5'].disabled = !unlockConditionForFZ9
	
	frontCheckboxesMap['0TF_A5'].disabled = !unlockConditionFor0TF

    frontCheckboxesMap['YN1_A5'].disabled = !unlockConditionForYN1
    frontCheckboxesMap['YN2_A5'].disabled = !unlockConditionForYN2
    frontCheckboxesMap['FC1_A5'].disabled = !unlockConditionForFC1

    frontCheckboxesMap['YFA_A5'].disabled = !unlockConditionForYFA
    frontCheckboxesMap['YFB_A5'].disabled = !unlockConditionForYFB
}


/**Gets images for all packages depending on selected packages */

function getImages_a5_s_line(frontCheckboxesMap) {
	for (const checkboxKey in frontCheckboxesMap) {
		getPackageImages_a5_s_line(checkboxKey, frontCheckboxesMap)
	}
}

function getPackageImages_a5_s_line(packageCode, checkboxesMap) {
	let specialPackage = '';
	//When in modal
	if (packageCode == 'YSI-YVJ' || packageCode == 'YSJ_A6-YVJ'){
		specialPackage = packageCode
		packageCode = packageCode == 'YSI-YVJ' ? 'YSI' : 'YSJ_A6'
	}

	const checkboxElement = checkboxesMap[packageCode]
	const imageSource = specialPackage != '' ? getPackageImageSource(specialPackage) : getPackageImageSource(packageCode)
	let pressedPackageImg = document.getElementById(specialPackage != ''? specialPackage + '-img' : packageCode + '-img')
	const isChecked = checkboxElement.checked || checkboxElement.parentElement.classList.contains('is-checked')

	
	if (checkboxesMap['YFA_A5'] && checkboxesMap['YFA_A5'].checked) {
		setTimeout(function() {
			let imgIds = ["FC1_A5-img", "Q8H_A5-img", "0UD_A5-img", "0TF_A5-img"];
			imgIds.forEach(function(id) {
				let img = document.getElementById(id);
				if (img) img.setAttribute("hidden", "");
			});
		}, 1);
	}


	//if image does not exist we create it
	if (pressedPackageImg == null) {
		if (!isChecked ) return
		let imageArray = document.querySelector('.image-wrap')
		let newImage = document.createElement('IMG')
		newImage.classList.add('overlay')
		newImage.src = imageSource
		newImage.id = specialPackage != '' ? specialPackage + '-img' : packageCode + '-img'
		imageArray.insertAdjacentElement('beforeend', newImage)
	} else {
		pressedPackageImg.hidden = !isChecked
	}
}

function updateBackgroundImage() {
	const isYN1_A5Checked = isCheckboxCheckedByAuiCode('YN1_A5');
	const isYN2_A5Checked = isCheckboxCheckedByAuiCode('YN2_A5');
	//Basisbild austauschen
    if (isYN1_A5Checked) {		
		document.getElementById("front_background_image").src="img/06_paketauswahl/a5/au401_a5_paketauswahl_sline_s_yn1/au401_a5_sline_s_yn1_paketauswahl.png";
	} else if (isYN2_A5Checked) {
		document.getElementById("front_background_image").src="img/06_paketauswahl/a5/au401_a5_paketauswahl_sline_s_yn2/au401_a5_sline_s_yn2_paketauswahl.png";
	} else {
		document.getElementById("front_background_image").src="img/06_paketauswahl/a5/au401_a5_paketauswahl_sline_s/au401_a5_sline_s_paketauswahl.png";
	}
}

function isCheckboxCheckedByAuiCode(auiCode) {
    const label = document.querySelector(`label[data-auicode="${auiCode}"]`);
    if (label) {
        const checkbox = label.querySelector('input[type="checkbox"]');
        return checkbox ? checkbox.checked : false;
    }
    return false;
}

document.addEventListener('DOMContentLoaded', function () {
	const isYN1_A5Checked = isCheckboxCheckedByAuiCode('YN1_A5');
	if(isYN1_A5Checked) {
		updateBackgroundImage();
	}
	const isYN2_A5Checked = isCheckboxCheckedByAuiCode('YN2_A5');
	if(isYN2_A5Checked) {
		updateBackgroundImage();
	}
	
});

export { addListeners_a5_s_line, saveStateWithAjax, checkLocks_a5_s_line, getImages_a5_s_line, getPackageImages_a5_s_line, checkSeatsAndSteeringWheelBadges_a5_s_line}

